import { Button, Modal } from 'antd'
import React from 'react'
import { MODAL_BREDD, MODAL_GRIND, MODAL_KNAPP, MODAL_KNAPP_FARLIG, modalTitel } from '../modalStil'

/**
 * GammaltUtkastModal – varning innan ett gammalt utkast återupptas.
 *
 * Svaren i ett utkast beskriver hur det kändes den dagen. Efter några veckor kan de
 * ha slutat gälla utan att någon märker det, för de ser likadana ut på skärmen som
 * färska svar. Att fortsätta på dem ger ett index som ser exakt ut men blandar två
 * tidpunkter.
 *
 * Ingen spärr, bara en fråga. Handläggaren vet saker vi inte vet – kanske gick det
 * bara två dagar av samtalet och resten var administration.
 */

/** Gränsen i dagar. Antons beslut: två veckor. */
export const GAMMALT_UTKAST_DAGAR = 14

export const utkastAlderIDagar = (created: string) =>
  Math.floor((Date.now() - new Date(created).getTime()) / (1000 * 60 * 60 * 24))

export interface GammaltUtkastModalProps {
  open: boolean
  /** Utkastets ålder i dagar. */
  alder: number
  onAterupptaAnda: () => void
  onBorjaOm: () => void
  onAvbryt: () => void
}

const GammaltUtkastModal: React.FC<GammaltUtkastModalProps> = ({
  open,
  alder,
  onAterupptaAnda,
  onBorjaOm,
  onAvbryt,
}) => (
  <Modal
    open={open}
    {...MODAL_GRIND}
    title={modalTitel('Utkastet är gammalt')}
    width={MODAL_BREDD}
    onCancel={onAvbryt}
    /*
      Egen fot: tre utfall ryms inte i Ant Designs ok/cancel.

      INGEN fylld knapp här, till skillnad från övriga modaler. Det vi rekommenderar –
      att börja om – är också det enda som inte går att ångra, och att göra den tyngst
      på skärmen vore att med färg putta någon in i en oåterkallelig handling. Rådet
      står i texten, där det går att förklara; knapparna väger lika.
    */
    footer={
      <div className="flex flex-wrap justify-end gap-2">
        <Button {...MODAL_KNAPP} onClick={onAvbryt}>
          Tillbaka
        </Button>
        <Button {...MODAL_KNAPP} onClick={onAterupptaAnda}>
          Återuppta ändå
        </Button>
        <Button {...MODAL_KNAPP_FARLIG} onClick={onBorjaOm}>
          Radera och börja om
        </Button>
      </div>
    }
  >
    <p className="m-0 text-base text-gray-700">
      Det påbörjade besöket är <span className="font-medium">{alder} dagar</span> gammalt.
    </p>
    <p className="mt-3 mb-0 text-base text-gray-700">
      Svaren beskriver hur det kändes då. Har det gått en tid kan de ha slutat stämma, och ett index som blandar två
      tidpunkter ser lika exakt ut som ett som inte gör det.
    </p>
    <p className="mt-3 mb-0 text-base text-gray-700">
      Vår rekommendation är att börja om. Vet du att svaren fortfarande gäller går det bra att fortsätta.
    </p>
  </Modal>
)

export default GammaltUtkastModal
